import $ from 'jquery'
import 'owl.carousel';
import { trace } from 'rytm-helpers';

let list = []
let startPosition = 0
let evenstAdded = false;

const getCarouselParamsResponsive = (el) => {
  switch (el.dataset.items) {
    case "1":
      return {
        0: {
          items: 1,
          // slideBy: "page",
        },
      }
    case "2":
      return {
        0: {
          items: 1,
          // slideBy: "page",
        },
        576: {
          items: 2,
          // slideBy: "page",
        },
        768: {
          items: 2,
          // slideBy: "page",
        },
        992: {
          items: 2,
          // slideBy: "page",
        },
        1200: {
          items: 2,
          // slideBy: "page",
        },
      }
    case "3":
      return {
        0: {
          items: 1,
          slideBy: 1,
        },
        576: {
          items: 2,
          slideBy: 1,
        },
        768: {
          items: 2,
          slideBy: 1,
        },
        992: {
          items: 2,
          slideBy: 1,
        },
        1200: {
          items: 3,
          slideBy: 1,
        },
      }
    case "4":
      return {
        0: {
          items: 1,
          // slideBy: "page",
        },
        576: {
          items: 2,
          // slideBy: "page",
        },
        768: {
          items: 3,
          // slideBy: "page",
        },
        992: {
          items: 4,
          // slideBy: "page",
        },
        1200: {
          items: 4,
          // slideBy: "page",
        },
      }
    case "5":
      return {
        0: {
          items: 1,
          // slideBy: "page",
        },
        460: {
          items: 2,
          // slideBy: "page",
        },
        576: {
          items: 2,
          // slideBy: "page",
        },
        768: {
          items: 3,
          // slideBy: "page",
        },
        992: {
          items: 4,
          // slideBy: "page",
        },
        1200: {
          items: 5,
          // slideBy: "page",
        },
      }
    case "10":
      return {
        0: {
          items: 3,
          // slideBy: "page",
        },
        360: {
          items: 4,
        },
        576: {
          items: 4,
          // slideBy: "page",
        },
        768: {
          items: 6,
          // slideBy: "page",
        },
        992: {
          items: 7,
          // slideBy: "page",
        },
        1200: {
          items: 9,
          // slideBy: "page",
        },
        1400: {
          items: 10,
          // slideBy: "page",
        },
        1600: {
          items: 11,
          // slideBy: "page",
        },
      }
    default:
      return {
        0: {
          items: 2,
          // slideBy: "page",
        },
        380: {
          items: 3,
          // slideBy: "page",
        },
        768: {
          items: 4,
          // slideBy: "page",
        },
        992: {
          items: 5,
          // slideBy: "page",
        },
        1200: {
          items: 6,
          // slideBy: "page",
        },
        1400: {
          items: 7,
          // slideBy: "page",
        },
      }
  }
}
const getCarouselParams = (el) => {
  const autoWidth = el.dataset.autowidth ? true : false
  const nav = el.dataset.hideNav ? false : true
  // const sufix = el.dataset.navWhite == "true" ? "_white"  : "_black"
  const sufix = "";
  const margin = el.dataset.margin ? parseInt(el.dataset.margin)  : 30
  return {
    nav,
    navText: [
      '<img src="/local/images/owl_arrow' + sufix + '_left.svg" alt="poprzedni" />', 
      '<img src="/local/images/owl_arrow' + sufix + '_right.svg" alt="następny" />'
    ],
    loop: el.dataset.loop ? el.dataset.loop == "true" : false,
    stagePadding: el.dataset.stagePadding ? 100 : 0,
    center: el.dataset.center ? el.dataset.center == "true" : true,
    margin,
    dots: false,
    autoplay: el.dataset.autoplay ? el.dataset.autoplay == "true" : false,
    // slideTransition: "linear",
    autoplayTimeout: 3500,
    autoplayHoverPause: false,
    autoplaySpeed: 500,
    navSpeed: 70,
    startPosition,
    autoWidth,
    responsive: getCarouselParamsResponsive(el)
  }
}

const initOwlCarousel = (el, index) => {
  // trace("init owl", el)
  let $carousel = $(el)
  $carousel.addClass('owl-carousel')
  $carousel.owlCarousel(getCarouselParams(el))
  list.push($carousel)
}
const destroyOwlCarousel = ($carousel, index) => {
  if (!$carousel) {
    return
  }
  trace("destroy carousel", $carousel)
  $carousel.trigger('destroy.owl.carousel').removeClass('owl-carousel owl-loaded')
  $carousel.find('.owl-stage-outer').children().unwrap()
}

const onOwlNextClick = (e) => {
  e.preventDefault();
  const selector = e.currentTarget.getAttribute("href");
  const carouselEl = selector ? document.querySelector(selector) : null;
  if (carouselEl) {
    trace("onOwlNextClick", e.currentTarget);
    $(carouselEl).trigger('next.owl.carousel');
  }
}
const onOwlPrevClick = (e) => {
  e.preventDefault();
  const selector = e.currentTarget.getAttribute("href");
  const carouselEl = selector ? document.querySelector(selector) : null;
  if (carouselEl) {
    $(carouselEl).trigger('prev.owl.carousel');
  }
}

export const destroyOwl = () => {
  list.forEach(destroyOwlCarousel)
  list = []
  if (evenstAdded) {
    $("body").off("click", ".mtk-owl-next", onOwlNextClick);
    $("body").off("click", ".mtk-owl-prev", onOwlPrevClick);
    evenstAdded = false;
  }
}
export const buildOwl = (startAt = 0) => {
  startPosition = startAt
  const list = [...document.querySelectorAll(".r-owl-carousel")]
  list.forEach(initOwlCarousel)
  if (!evenstAdded) {
    $("body").on("click", ".mtk-owl-next", onOwlNextClick);
    $("body").on("click", ".mtk-owl-prev", onOwlPrevClick);
    evenstAdded = true;
  }
}